/* Price test, groups B to D (see snippets/price-test-head.liquid, which picks the group and starts loading its prices).
   The shopper stays on the real products; this swaps what they see and what they buy:
   - text marked data-pt-products="<handle>:<cents> ..." or data-pt-variants="<variant id>:<cents> ..." becomes the
     lowest group price of those products or variants (the cents are the main price, kept for anything not in the test)
   - Andrew's product and gift pages read their variants from [data-adp-json] / [data-adp-gift-json], and Pawla her sizes
     from [data-adp-pawla-json]; product-ad.js waits on PriceTest.whenReady (product-ad-gift.js and product-pawla.js must too),
     so the ids and prices are the group's before it starts
   - anything added to the cart (product forms, the cart drawer, Pawla, upsells) is switched to the group's copy
   Every group, A included, is saved on the cart (_price_group, _price_source, and _upsell_group when the upsell test is
   on), sent to Google Analytics 4 as experiment_assigned and tagged in Clarity. */
(function () {
  var test = window.PriceTest;
  if (!test) return;
  var group = test.group;

  var once = function (key, run) {
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) {}
    run();
  };
  // Crawlers get group A and no cart. Saved once per cart (the cart cookie names it), so an order placed later in the
  // same visit, on a new cart, is labelled too.
  var cartId = (document.cookie.match(/(?:^|; )cart=([^;]*)/) || [])[1] || '';
  var attributes = { _price_group: group, _price_source: test.source };
  if (test.upsell) attributes._upsell_group = test.upsell;
  if (test.source !== 'bot') once('pt:saved:' + group + ':' + test.source + ':' + (test.upsell || '') + ':' + cartId, function () {
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {});
  });
  // Visitors per group, which the report needs next to the orders. They go to Pet Portraits' own GA4 property
  // (G-BFSHC7NJ03, loaded by snippets/pp-consent-scripts.liquid once analytics cookies are allowed). That tag loads after
  // this script, so experiment_assigned waits for it (up to 30 s) and goes to it by name. A new assignment is remembered until GA4
  // has it, so a visitor who leaves the first page before Google's tag loads is still counted as new on their next page.
  // Clarity (window.ndTrack, snippets/nd-track.liquid) gets the groups as session tags too.
  if (test.source !== 'bot') {
    var ga4 = test.ga4 || 'G-BFSHC7NJ03';
    var sentKey = 'pt:sent:' + group + ':' + (test.upsell || '');
    var firstKey = 'pp_pt_first';
    if (window.ndTrack) window.ndTrack(null, { price_group: group, price_source: test.source, upsell_group: test.upsell || 'none' });
    var first = !!(test.fresh || test.upsellFresh);
    var sent = false;
    try {
      if (first) localStorage.setItem(firstKey, '1');
      first = first || localStorage.getItem(firstKey) === '1';
      sent = !!sessionStorage.getItem(sentKey);
    } catch (e) {}
    if (!sent || first) {
      var tries = 0;
      var waitForGa = setInterval(function () {
        var tagged = window.google_tag_manager && window.google_tag_manager[ga4];
        if (!tagged && ++tries < 60) return;
        clearInterval(waitForGa);
        if (!tagged) return;
        window.dataLayer = window.dataLayer || [];
        // gtag() itself may not be defined yet, and gtag commands must be pushed as an arguments object
        (function () { window.dataLayer.push(arguments); })('event', 'experiment_assigned', {
          send_to: ga4, catalog_arm: group, upsell_arm: test.upsell || 'none', price_source: test.source,
          first_visit: first ? 'true' : 'false',
        });
        try {
          sessionStorage.setItem(sentKey, '1');
          localStorage.removeItem(firstKey);
        } catch (e) {}
      }, 500);
    }
  }

  var waiting = [];
  test.whenReady = function (run) { waiting.push(run); };
  if (group === 'A' || !test.ready) {
    test.whenReady = function (run) { run(); };
    return;
  }

  var byVariant = null;
  var byProduct = null;
  var money = function (cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  };
  var pairs = function (text) {
    return (text || '').trim().split(/\s+/).filter(Boolean).map(function (pair) {
      var at = pair.lastIndexOf(':');
      return [pair.slice(0, at), Number(pair.slice(at + 1))];
    });
  };
  var lowest = function (el) {
    var best = null;
    pairs(el.getAttribute('data-pt-products')).forEach(function (p) {
      var price = byProduct[p[0]] != null ? byProduct[p[0]] : p[1];
      if (best === null || price < best) best = price;
    });
    pairs(el.getAttribute('data-pt-variants')).forEach(function (p) {
      var price = byVariant[p[0]] ? byVariant[p[0]][1] : p[1];
      if (best === null || price < best) best = price;
    });
    return best;
  };
  var swap = function (root) {
    if (!byVariant || !root.querySelectorAll) return;
    var marked = Array.from(root.querySelectorAll('[data-pt-products], [data-pt-variants]'));
    if (root.matches && root.matches('[data-pt-products], [data-pt-variants]')) marked.push(root);
    marked.forEach(function (el) {
      var price = lowest(el);
      if (price === null) return;
      // Alpine would put the main price back on start-up
      el.removeAttribute('x-html');
      var parent = el.parentElement && el.parentElement.closest('[x-html]');
      if (parent) parent.removeAttribute('x-html');
      var text = money(price);
      if (el.textContent.trim() !== text) el.textContent = text;
    });
  };
  // Andrew's portrait page ([data-adp-json]) and gift page ([data-adp-gift-json]); Pawla's "8x10 from $49.95" sizes follow
  var pdp = function () {
    var node = document.querySelector('[data-adp-json], [data-adp-gift-json]');
    if (!node || node.dataset.ptDone) return;
    var data = JSON.parse(node.textContent);
    data.variants.forEach(function (v) {
      var copy = byVariant[String(v.id)];
      // v.r keeps the real variant id for the page address, so a shared link opens the same size for anyone
      if (copy) { v.r = v.id; v.id = copy[0]; v.p = copy[1]; v.c = 0; }
    });
    var current = byVariant[String(data.current)];
    if (current) data.current = current[0];
    node.textContent = JSON.stringify(data);
    node.dataset.ptDone = '1';
    var input = document.querySelector('[data-adp-id]');
    if (input && byVariant[input.value]) input.value = byVariant[input.value][0];
    var pawla = document.querySelector('[data-adp-pawla-json]');
    if (!pawla || data.size == null) return;
    var config = JSON.parse(pawla.textContent);
    config.sizes = (config.sizes || []).map(function (entry) {
      var value = entry.split(' from ')[0];
      var from = null;
      data.variants.forEach(function (v) { if (v.o[data.size] === value && (from === null || v.p < from)) from = v.p; });
      return from === null ? entry : value + ' from $' + (from % 100 ? (from / 100).toFixed(2) : from / 100);
    });
    pawla.textContent = JSON.stringify(config);
  };
  var copyOf = function (id) {
    var copy = byVariant && byVariant[String(id)];
    return copy ? String(copy[0]) : id;
  };

  // Cart adds, whichever way they're sent
  var cartAdd = /\/cart\/add(\.js|\.json)?(\?|$)/;
  var idKey = /^(id|items\[\d+\]\[id\])$/;
  var rewrite = function (body) {
    if (!byVariant || body == null) return body;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      Array.from(body.keys()).filter(function (k) { return idKey.test(k); }).forEach(function (k) { body.set(k, copyOf(body.get(k))); });
      return body;
    }
    if (body instanceof URLSearchParams) {
      Array.from(body.keys()).filter(function (k) { return idKey.test(k); }).forEach(function (k) { body.set(k, copyOf(body.get(k))); });
      return body;
    }
    if (typeof body === 'string') {
      try {
        var json = JSON.parse(body);
        if (json.id != null) json.id = Number(copyOf(json.id));
        (json.items || []).forEach(function (item) { item.id = Number(copyOf(item.id)); });
        return JSON.stringify(json);
      } catch (e) {
        var params = new URLSearchParams(body);
        return rewrite(params).toString();
      }
    }
    return body;
  };
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && cartAdd.test(url) && init && init.body) init = Object.assign({}, init, { body: rewrite(init.body) });
    } catch (e) {}
    return nativeFetch.call(this, input, init);
  };
  var open = XMLHttpRequest.prototype.open;
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.ptCartAdd = cartAdd.test(String(url));
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try { if (this.ptCartAdd) body = rewrite(body); } catch (e) {}
    return send.call(this, body);
  };
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || !cartAdd.test(form.action)) return;
    form.querySelectorAll('[name="id"]').forEach(function (input) { input.value = copyOf(input.value); });
  }, true);

  var release = function () {
    document.documentElement.classList.remove('pt-wait');
    var run = waiting;
    waiting = [];
    test.whenReady = function (next) { next(); };
    run.forEach(function (next) { next(); });
  };
  var settled = false;
  var settle = function (data) {
    if (settled) return;
    settled = true;
    if (!data) {
      // No price list: this visit shows and sells the main price, which stays consistent
      byVariant = null;
      release();
      return;
    }
    byVariant = {};
    byProduct = {};
    Object.keys(data.products).forEach(function (handle) {
      var product = data.products[handle];
      byProduct[handle] = product.min;
      Object.keys(product.v).forEach(function (id) { byVariant[id] = product.v[id]; });
    });
    pdp();
    var start = function () {
      swap(document);
      // New cards, the cart drawer, and scripts that rewrite a marked price
      new MutationObserver(function (changes) {
        changes.forEach(function (change) {
          change.addedNodes.forEach(swap);
          var target = change.target.nodeType === 1 ? change.target : change.target.parentElement;
          var marked = target && target.closest('[data-pt-products], [data-pt-variants]');
          if (marked) swap(marked);
        });
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    release();
  };
  test.ready.then(settle, function () { settle(null); });
  // A price list that never answers must not leave the product page waiting for good
  setTimeout(function () { settle(null); }, 8000);
})();
